// Actions
export const INSTANT_QUOTE__GET = 'INSTANT_QUOTE__GET';
export const INSTANT_QUOTE__RESET_QUOTE = 'INSTANT_QUOTE__RESET_QUOTE';
export const INSTANT_QUOTE__GENERATE_QUOTE = 'INSTANT_QUOTE__GENERATE_QUOTE';
export const INSTANT_QUOTE__ACCEPT_QUOTE = 'INSTANT_QUOTE__ACCEPT_QUOTE';
export const INSTANT_QUOTE__ACCEPT_PENDING_QUOTE = 'INSTANT_QUOTE__ACCEPT_PENDING_QUOTE';
export const INSTANT_QUOTE__REJECT_QUOTE = 'INSTANT_QUOTE__REJECT_QUOTE';
export const INSTANT_QUOTE__SUGGESTED_JOB_CLICK = 'INSTANT_QUOTE__SUGGESTED_JOB_CLICK';
// Mutations
export const INSTANT_QUOTE__MUTATE_LOADING_STATUS = 'INSTANT_QUOTE__MUTATE_LOADING_STATUS';
export const INSTANT_QUOTE__MUTATE_CURRENT_QUOTE = 'INSTANT_QUOTE__MUTATE_CURRENT_QUOTE';
